module.exports = __webpack_public_path__ + "img/kuangjiao_xc7.d0a89ddc.jpg";